import React, { lazy, Suspense } from "react";
import "@fontsource/poppins";
import "./App.css";
import MediaQuery from "react-responsive";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";

const Navbar =lazy (() => import("./PostEvent/Navbar"));
const Body = lazy(() => import("./PostEvent/Body"));
const EventMemories = lazy(() =>
  import("./PostEvent/EventMemories/EventMemories.js")
);
const EventMemoriesMobile = lazy(() =>
  import("./PostEvent/EventMemories/EventMemoriesMobile.js")
);
const SocialMedia = lazy(() =>
  import("./PostEvent/SocialMedia/SocialMedia.js")
);
const Experience = lazy(() => import("./PostEvent/Experience.js"));

const ThankYou = lazy(() => import("./PostEvent/ThankYou/ThankYou.js"));

const Footer = lazy(() => import("./PostEvent/Footer.js"));

function App() {
  const imgCDNURL = process.env.REACT_APP_POSTTACA_CDN_URL;

  return (
    <div className="bodyContainer">
      <CacheBuster
      currentVersion={appversion.version}
      isEnabled={true} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      // loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
      metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
    >
      {/* <img
        src={imgCDNURL + "five-dots-white-group.png"}
        className="five-dots-white-group img-fluid"
      /> */}
      <img
        src={imgCDNURL + "desktopbannerbg.webp"}
        className="body-bg img-fluid"
      />
      <Suspense fallback={<div />}>
        <Navbar />
      </Suspense>
      <Suspense fallback={<div />}>
        <Body />
      </Suspense>
      <Suspense fallback={<div />}>
        <Experience />
      </Suspense>
      <MediaQuery minWidth={993}>
        <Suspense fallback={<div />}>
          <EventMemories />
        </Suspense>
      </MediaQuery>
      {/* Renders the components of mobile and tablet view */}
      <MediaQuery maxWidth={992}>
        <Suspense fallback={<div />}>
          <EventMemoriesMobile />
        </Suspense>
      </MediaQuery>
      <Suspense fallback={<div />}>
        <SocialMedia />
      </Suspense>{" "}
      <Suspense fallback={<div />}>
        <ThankYou />
      </Suspense>
      <Suspense fallback={<div />}>
        <Footer />
      </Suspense>
      </CacheBuster>
    </div>
  );
}

export default App;

